import { PageNavItem } from '@/components/models/travel/navs/PageNavigation/types'

const navItemsHook = (items: PageNavItem[]): PageNavItem[] => {
  return items
}

export default navItemsHook
